import { types } from 'mobx-state-tree'

export const AuthenticationStoreModel = types
  .model('Tweet', {
    authenticated: false,
  })
  .actions((self) => ({
    setAuthenticated(authenticated: boolean) {
      self.authenticated = authenticated
    },
  }))
